<template>
  <v-navigation-drawer
    app
    clipped
    color="#f7f7fa"
    class="navigation-drawer elevation-1"
    :mini-variant.sync="mini"
    :width="drawerWidth"
    :mini-variant-width="miniWidth"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
  >
    <v-list dense>
      <v-list-item
        v-for="item in filteredNavItems"
        :key="item.title"
        :to="item.to"
        router
        :exact="checkExactRouteActive(item)"
        active-class="primary--text"
      >
        <v-list-item-action class="mr-3">
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content v-if="!mini">
          <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'NavigationDrawer',
  data () {
    return {
      mini: true,
      miniWidth: 56,
      drawerWidth: 144
    }
  },
  methods: {
    toggleDrawer () {
      this.mini = !this.mini
    },
    handleMouseEnter () {
      this.toggleDrawer()
    },
    handleMouseLeave () {
      this.toggleDrawer()
    },
    checkExactRouteActive (item) {
      return item.to.name === 'contracts'
    }
  },
  computed: {
    ...mapState(['isAdmin', 'isAreaManager', 'isInsightsViewer']),
    filteredNavItems () {
      const items = [
        {
          title: 'menuHeaders.contracts',
          to: { name: 'contracts' },
          icon: 'mdi-file-document-outline',
          protected: false
        },
        {
          title: 'menuHeaders.insights',
          to: { name: 'insights' },
          icon: 'mdi-chart-bar',
          protected: true,
          insightsViewerAllowed: true
        },
        {
          title: 'menuHeaders.admin',
          to: { name: 'Admin' },
          icon: 'mdi-cog-outline',
          protected: true,
          adminAllowed: true,
          areaManagerAllowed: true
        }
      ]
      return items.filter(item =>
        !item.protected ||
        (this.isAdmin && item.adminAllowed) ||
        (this.isAreaManager && item.areaManagerAllowed) ||
        (this.isInsightsViewer && item.insightsViewerAllowed)
      )
    }
  }
}
</script>

<style scoped>
.navigation-drawer {
  background-color: #fbfbfd !important;
  transition: all 0.2s;
}
</style>
